module.exports = __webpack_public_path__ + "img/icon-category-casarodante.79f2c1dc.png";